// extracted by mini-css-extract-plugin
export var growableInput = "_6q-0";
export var tagContainer = "_6q-2";
export var textInput = "_6q-1";